import { Type } from '@angular/core';
import { setFieldBuilderNamespace } from './field-builder.namespace';
import { TextFieldBuilder } from './field-builder.text';
import { NumberFieldBuilder } from './field-builder.number';
import { DateFieldBuilder } from './field-builder.date';
import { DateTimeFieldBuilder } from './field-builder.datetime';
import { TimeFieldBuilder } from './field-builder.time';
import { ForeignKeyFieldBuilder } from './field-builder.foreign-key';
import { CheckboxFieldBuilder } from './field-builder.checkbox';
import { DropdownFieldBuilder } from './field-builder.dropdown';

export class FieldBuilder {
  private static namespace: string = '';

  static setNamespace(ns: string): typeof FieldBuilder {
    this.namespace = ns;
    setFieldBuilderNamespace(ns);
    return this;
  }

  static text(key: string, label: string) {
    return new TextFieldBuilder(key, label);
  }

  static number(key: string, label: string) {
    return new NumberFieldBuilder(key, label);
  }

  static date(key: string, label: string) {
    return new DateFieldBuilder(key, label);
  }

  static datetime(key: string, label: string) {
    return new DateTimeFieldBuilder(key, label);
  }

  static time(key: string, label: string) {
    return new TimeFieldBuilder(key, label);
  }

  static foreignKey<TService>(key: string, label: string, service: Type<TService>) {
    return new ForeignKeyFieldBuilder<TService>(key, label, service);
  }

  static checkbox(key: string, label: string) {
    return new CheckboxFieldBuilder(key, label);
  }

  static dropdown(key: string, label: string) {
    return new DropdownFieldBuilder(key, label);
  }
}

export { TextFieldBuilder } from './field-builder.text';
export { NumberFieldBuilder } from './field-builder.number';
export { DateFieldBuilder } from './field-builder.date';
export { DateTimeFieldBuilder } from './field-builder.datetime';
export { TimeFieldBuilder } from './field-builder.time';
export { ForeignKeyFieldBuilder } from './field-builder.foreign-key';
export { CheckboxFieldBuilder } from './field-builder.checkbox';
export { DropdownFieldBuilder } from './field-builder.dropdown';
